import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Tabs,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Checkbox,
  Radio,
  Avatar,
  Space,
  Row,
  Col,
  Divider,
} from "antd";
import { UserOutlined, PlusOutlined } from "@ant-design/icons";

import Main from "../../components/layout/Main";
import LockImage from "../../assets/images/lock-image.svg";
import StarImage from "../../assets/images/star-image-upgrade.svg";
import ProfileImage from "../../assets/images/leaderboard-profile.jpg";
import BronzeImage from "../../assets/images/bronze-button-image.svg";
import SilverImage from "../../assets/images/silver-butto-image.svg";
import GoldImage from "../../assets/images/gold-button-image.svg";
import { CrossIcon } from "lucide-react";

const { TabPane } = Tabs;
const { TextArea } = Input;

const players = [{ name: "PlayerOne" }, { name: "NinjaMaster" }];

const CreateTournaments = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("private");
  const [form] = Form.useForm();
  const [selected, setSelected] = useState("gold");

  const getButtonClass = (type) => {
    return selected === type ? "selected-trophy-button" : "";
  };
  return (
    <Main>
      <div className="games-versoin-name-section all-games-componanat">
        {/* <div className="games-versoin-name-header">
          <h4>Call of Duty</h4>
        </div>

        <div className="games-tabs">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="custom-tabs"
          >
            <TabPane tab="Public" key="public" />
            <TabPane tab="Private" key="private" />
          </Tabs>
        </div> */}

        {activeTab === "private" && (
          <>
            <div className="only-premium-menber-card">
              <div className="only-premium-menber-card-inner">
                <img src={LockImage} alt="lock" />
                <p>
                  Only premium users can create or join private tournaments.
                </p>
                <Button
                  className="Fill-button-small"
                  onClick={() => navigate("/subscriptions")}
                >
                  <img src={StarImage} alt="star" /> Upgrade to Premium
                </Button>
              </div>
              <div className="or-deviders-or">Or</div>
              <div className="only-premium-menber-card-inner">
                <img src={LockImage} alt="lock" />
                <p>
                  Private tournaments are for premium users. You can also unlock
                  this match using:
                </p>
                <Button
                  className="Fill-button-small"
                  onClick={() => navigate("/create-private-tournament")}
                >
                  Join for 10 Tokens
                </Button>
              </div>
            </div>

            {/* <Form layout="vertical" form={form} className="tournament-form">
              <Row gutter={24}>
                <Col span={24} md={10}>
                  <Form.Item label="Tournament Name" name="name">
                    <Input placeholder="Enter tournament name" />
                  </Form.Item>

                  <Form.Item label="Game" name="game">
                    <Select placeholder="Select a Game">
                      <Select.Option value="game1">Game 1</Select.Option>
                      <Select.Option value="game2">Game 2</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item label="Max Players" name="maxPlayers">
                    <Input placeholder="e.g. 32" />
                  </Form.Item>

                  <Form.Item label="Start Date & Time" name="startDate">
                    <DatePicker
                      showTime
                      format="MM/DD/YYYY HH:mm"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="add-stream-checkbox"
                    label={
                      <>
                        <span>Add Stream Link</span>
                        <Checkbox.Group>
                          <Checkbox value="kick">Kick</Checkbox>
                          <Checkbox value="twitch">Twitch</Checkbox>
                        </Checkbox.Group>
                      </>
                    }
                    name="streamLink"
                  >
                    <Input placeholder="Paste link here" />
                  </Form.Item>

                  <Form.Item
                    name="shuffleLogic"
                    label="Player Shuffling Logic"
                    className="add-stream-checkbox add-stream-checkbox-new"
                  >
                    <Checkbox>
                      Prevent online players facing each other in Round 1
                    </Checkbox>
                  </Form.Item>

                  <Form.Item label="Other Conditions" name="conditions">
                    <TextArea
                      rows={4}
                      placeholder="Describe any extra conditions (optional)"
                    />
                  </Form.Item>

                  <Form.Item label="Trophy Structure" name="trophy">
                    <div className="button-raiting-groupp">
                      <Button
                        className={getButtonClass("gold")}
                        onClick={() => setSelected("gold")}
                      >
                        <img
                          src={GoldImage}
                          alt="Gold"
                          style={{ height: 16, marginRight: 8 }}
                        />
                        Gold
                      </Button>
                      <Button
                        className={getButtonClass("silver")}
                        onClick={() => setSelected("silver")}
                      >
                        <img
                          src={SilverImage}
                          alt="Silver"
                          style={{ height: 16, marginRight: 8 }}
                        />
                        Silver
                      </Button>
                      <Button
                        className={getButtonClass("bronze")}
                        onClick={() => setSelected("bronze")}
                      >
                        <img
                          src={BronzeImage}
                          alt="Bronze"
                          style={{ height: 16, marginRight: 8 }}
                        />
                        Bronze
                      </Button>
                    </div>
                  </Form.Item>

                  <div className="streaming-requirements">
                    <h4>Streaming Requirement</h4>
                    <Form.Item
                      name="shuffleLogic"
                      className="add-stream-checkbox add-stream-checkbox-new m-0"
                    >
                      <Checkbox>
                        Players must submit stream link (Twitch/Kick) before
                        start
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className="tournement-live-lines-main">
                    <h6>30 min buffer before tournament goes live</h6>
                    <h6>Auto-disqualification if stream link is missing</h6>
                  </div>

                  <div className="cancel-and-submit-button">
                    <Button className="light-button">Cancel</Button>
                    <Button className="Fill-button" htmlType="submit"     onClick={() => navigate("/tournaments-details")}>
                      Create Tournament
                    </Button>
                  </div>
                </Col>

                <Col span={24} md={10}>
                  <div className="invite-players-box">
                    <div className="invite-header">
                      <h4>Invite Players</h4>
                      <span>Add</span>
                    </div>
                    {players.map((player, idx) => (
                      <div key={idx} className="player-item">
                        <div className="profil-image-and-name">
                          <img src={ProfileImage} />
                          <span>{player.name}</span>
                        </div>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="#6B7280"
                            stroke="#6B7280"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-x-icon lucide-x"
                          >
                            <path d="M18 6 6 18" />
                            <path d="m6 6 12 12" />
                          </svg>
                        </span>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </Form> */}
          </>
        )}
      </div>
    </Main>
  );
};

export default CreateTournaments;
